import { colors } from "utils/theme";

export const DailyHeader = ({ shift, handleOpenShift }) => {
  return (
    <>
      <h6 className="text-black  text-lg font-light ">
        Punto de venta para el dia {new Date().toLocaleDateString()}
      </h6>

      {!shift.isInProgress && (
        <div className="w-full lg:w-6/12 my-4">
          <button
            onClick={handleOpenShift}
            style={{
              height: 45,
              width: "40%",
              background: colors.mantis,
            }}
            className="  text-white  font-bold uppercase text-xs rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="button"
          >
            Apertura turno {new Date().toLocaleDateString()}
          </button>
        </div>
      )}
    </>
  );
};
